<template>
  <div class='theme-file__holder'>
    <label :for='id' class='theme-file'>
      <span class='theme-btn theme-btn--theme theme-btn--small theme-file__desktop-btn' :class="{'theme-file__desktop-btn--white': white}">
        <i class='icon-upload' style='font-size: 20px;'/>
        <span class='theme-file__button-text'>
          {{ locales && locales.common && locales.common.choose_file }}
        </span>
      </span>
      <span class='theme-btn theme-btn--theme theme-btn--square theme-btn--square--small theme-file__mobile-btn' :class="{'theme-file__mobile-btn--white': white}">
        <i class='icon-upload' style='font-size: 20px;'/>
      </span>
      <span class='theme-file__text'>
        {{ fileName ? fileName : (locales && locales.common && locales.common.no_file_chosen) }}
      </span>
    </label>
    <input
      style='display: none;'
      :class='inputClass'
      type='file'
      :accept='accept'
      :name="name"
      :id='id'
      @change='change'
      :ref="id"
    />
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    props: {
      name: {
        default: 'file',
        type: String,
      },
      accept: {
        default: '',
        type: String,
      },
      id: {
        default: '',
        type: String,
      },
      inputClass: {
        default: '',
        type: String,
      },
      white: {
        default: false,
        type: Boolean,
      },
    },
    data() {
      return {
        fileName: '',
      };
    },
    computed: {
      ...mapGetters(["metadata", "locales"])
    },
    methods: {
      change: function(event) {
        this.$emit('change', event);
        if (event.target.files && event.target.files[0]) {
          this.fileName = event.target.files[0].name;
        } else {
          this.fileName = '';
        }
      },
      clearInput: function () {
        this.fileName = '';
        this.$refs[this.id].value = '';
      }
    },
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/ThemeFile.vue